import AppConsole from "app/AppConsole";

const useAppConsole = (component: string) => AppConsole(component);
export default useAppConsole;